import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AdminOrgUnit } from '../data/admin-org-unit';
import { ApprovalUserData } from '../data/approval-user-data';
import { ProcessListItem } from '../data/process-list-item';

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  private http = inject(HttpClient);

  controllerURL = '/admin';

  getOrgUnits(): Observable<AdminOrgUnit[]> {
    return this.http.get<AdminOrgUnit[]>(environment.apiUrl + this.controllerURL + '/org-units');
  }

  getEmployee(id: string): Observable<ApprovalUserData> {
    return this.http.get<ApprovalUserData>(environment.apiUrl + this.controllerURL + '/employees/' + id);
  }

  getEmployeeProcesses(username: string, uidNumber: string): Observable<ProcessListItem[]> {
    const params = new HttpParams()
      .append('username', username)
      .append('uidNumber', uidNumber);
    return this.http.get<ProcessListItem[]>(environment.apiUrl + this.controllerURL + '/employee-process', { params });
  }
}
